var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.17a.74.74 0 00-.21-.57.78.78 0 00-.57-.23h-3.75a.81.81 0 00-.79.8v.31a.87.87 0 00.85.75h1.31l-6.51 6.49a.93.93 0 001.3 1.28l6.52-6.5v1.38a.82.82 0 00.24.59.72.72 0 00.55.22h.26a.76.76 0 00.8-.75V5.17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.36 10.53a.93.93 0 00-.93.92v6.34H5.85V7.93h7.06a.93.93 0 000-1.86H5.42A1.43 1.43 0 004 7.5v10.72a1.43 1.43 0 001.42 1.42h11.44a1.43 1.43 0 001.42-1.42v-6.77a.92.92 0 00-.92-.92z"
  })));
}
export default SvgLink;